import { SHIPMENT_FILTER_DATES_FIELDS } from '@/contants/Fields';
import { DEFAULT_DATE_FORMAT } from '@/contants/common';
import { getShipmentListInProgress, setShipmentFilters, setShipmentList } from '@/redux/Savers/SaversActions';
import { convertDateESTToUTCToUserLocal, convertUserDayTimeToEST, routeFileSelector } from '@/utilz';
import { Button, Col, Form, Row } from 'antd';
import { clone } from 'es-toolkit';
import moment from 'moment';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SaversFilterContent from './SaversFilterContent';
import { getShipmentDefaultFilters } from './constants';

const SaversShipmentFilters = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const shipmentFilters = useSelector((state) => state.shipment.shipmentFilters, shallowEqual);

  useEffect(() => {
    if (shipmentFilters) {
      const data = clone(shipmentFilters);
      for (const key in data) {
        if (SHIPMENT_FILTER_DATES_FIELDS.includes(key)) {
          if (data[key]) {
            data[key] = convertDateESTToUTCToUserLocal(data[key]);
          } else {
            data[key] = '';
          }
        }
      }
      data.ShipmentStatus = data?.ShipmentStatus ? data?.ShipmentStatus?.split(',') : [];
      form.setFieldsValue(data);
    }
  }, [form, shipmentFilters]);

  const handleFilterSubmit = (data) => {
    const preparedData = clone({
      ...getShipmentDefaultFilters(),
      ...data,
    });
    for (const key in preparedData) {
      if (SHIPMENT_FILTER_DATES_FIELDS.includes(key) && preparedData[key]) {
        if (key === 'CreatedDateFrom' || key === 'ExpShipFrom') {
          preparedData[key] = convertUserDayTimeToEST(preparedData[key], 'start');
        } else if (key === 'CreatedDateTo' || key === 'ExpShipTo') {
          preparedData[key] = convertUserDayTimeToEST(preparedData[key], 'end');
        } else {
          preparedData[key] = moment(preparedData[key]).format(DEFAULT_DATE_FORMAT);
        }
      }
      preparedData.ShipmentStatus = preparedData?.ShipmentStatus ? preparedData.ShipmentStatus.join(',') : '';
      dispatch(
        setShipmentList({
          data: [],
          progressing: true,
          totalRecords: 0,
          isFirstTime: false,
        }),
      );
      dispatch(setShipmentFilters({ ...preparedData, pageNumber: 1 }));
      dispatch(getShipmentListInProgress());
    }
  };

  const handleClear = () => {
    form.resetFields();
    form.setFieldsValue({
      CreatedDateFrom: moment(new Date()).subtract(1, 'months'),
      CreatedDateTo: moment(new Date()),
    });
  };

  return (
    <div className="d-flex flex-direction-column overflow-hidden h-100 br-4">
      <div className="custom-scroll-bar overflow-x-hidden mb-15 flex-1">
        <Form onFinish={handleFilterSubmit} form={form} initialValues={{ createdByType: 1, modifiedByType: 1 }}>
          <SaversFilterContent form={form} />
        </Form>
      </div>
      <Row className="px-15" gutter={15}>
        <Col sm={24} md={12}>
          <Button fullWidth type="default" onClick={handleClear} buttonType="button" id="shipment-filter-clear">
            {t('translation:default.buttons.clear')}
          </Button>
        </Col>
        <Col sm={24} md={12}>
          <Button
            fullWidth
            type="primary"
            onClick={() => form.submit()}
            buttonType="submit"
            id="shipment-filter-search"
          >
            {t('translation:default.buttons.search')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default SaversShipmentFilters;
